import { render, staticRenderFns } from "./ChatMessageTranslateInline.vue?vue&type=template&id=56a3a3cf&scoped=true"
import script from "./ChatMessageTranslateInline.vue?vue&type=script&lang=js"
export * from "./ChatMessageTranslateInline.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageTranslateInline.vue?vue&type=style&index=0&id=56a3a3cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3a3cf",
  null
  
)

export default component.exports